/* React */
import React from "react";

/* Ionic */
import { qrCode as qrCodeIcon } from "ionicons/icons";

/* React-Redux */
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";

/* React-Hook-Form */
import { useForm } from "react-hook-form";

/* Thunks */
import { loginWithOtp } from "src/redux/thunks/auth/loginWithOtpThunk";

/* Utils */
import useCredentials from "src/utils/hooks/useCredentials";

/* Component(s) */
import QRCodeContainer from "src/components/login/qr-code-container/QRCodeContainer";
import FormInput from "src/components/shared/input/form-input/FormInput";
import PrimaryButton from "src/components/shared/buttons/primary-button/PrimaryButton";

/* Stylesheet */
import styles from "./SecondFactor.module.scss";

/* Interface(s) */
import { TwoFaLoginRequest } from "src/shared/interfaces/api/Login";

const SecondFactor: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  // authState
  const authState = useSelector(
    (state: RootState) => state.auth
  );

  const { twoFa } = authState;

  const {
    register,
    formState: { errors },
    setValue,
    trigger,
    clearErrors,
    handleSubmit,
  } = useForm();

  const initialCredentials: TwoFaLoginRequest = {
    usernameEmail: twoFa.credentials.usernameEmail,
    password: twoFa.credentials.password,
    code: "",
  };

  const { credentials, handleCredentials } = useCredentials(
    {
      initialCredentials,
      setValue,
      trigger,
    }
  );

  const onSubmit = () => {
    dispatch(loginWithOtp(credentials));
  };

  return (
    <form
      data-cy="second-factor-container"
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      {twoFa?.qrCodeRequired ? (
        <QRCodeContainer
          code={twoFa?.qrCode}
          otpUrl={twoFa?.otpUrl}
        />
      ) : (
        <div className={styles.info_message}>
          Enter the <span>code</span> provided by your
          authenticator app
        </div>
      )}
      <FormInput
        testId={"otp-input"}
        register={register("code", {
          required: "Code required",
        })}
        errors={errors}
        clearErrors={clearErrors}
        type={"number"}
        name={"code"}
        placeholder={"Enter code"}
        value={credentials.code}
        icon={qrCodeIcon}
        onChange={handleCredentials}
      />
      <PrimaryButton
        testId={"submit-btn"}
        type={"submit"}
        ariaLabel={"Login"}
        label={"Login"}
        disabled={credentials.code?.length === 0}
      />
    </form>
  );
};

export default SecondFactor;
